<template>
  <div v-if="loading" class="lab-loading">
    Loading...
  </div>
  <div v-else-if="error" class="container mx-auto px-4 py-16 text-center">
    <p class="text-lg font-roboto">{{ error }}</p>
    <p class="mt-2 font-roboto text-gray-600">
      <router-link to="/labs" class="text-blue-600 hover:text-blue-800 underline">Back to Labs</router-link>
      or <router-link to="/contact" class="text-blue-600 hover:text-blue-800 underline">get in touch</router-link>.
    </p>
  </div>
  <div v-else class="lab-content">
    <div class="container mx-auto px-4 py-8">
      <section class="my-8">
        <h1 class="text-4xl font-bold text-center font-orbitron mb-4">{{ lab.title }}</h1>
        <p v-if="lab.seeking_investment" class="text-center">
          <span
            class="inline-block rounded-full bg-amber-100 px-4 py-1 text-sm font-semibold uppercase tracking-wide text-amber-900">
            Seeking investment
          </span>
        </p>
      </section>
    </div>
    <div class="container mx-auto px-4 py-8">
      <section>
        <div class="lab-content-text text-lg font-roboto" v-html="convertMarkdownToHtml(lab.full_text)"></div>
        <div class="text-lg mt-4 font-roboto">
          <div v-if="Array.isArray(lab.remote_url)">
            <div v-for="(url, index) in lab.remote_url" :key="index">
              <a :href="url" target="_blank" class="flex items-center gap-2 text-blue-600 hover:text-blue-800 underline">
                Launch {{ lab.title }} (Link {{ index + 1 }})
                <font-awesome-icon icon="external-link-alt" /> <!-- Font Awesome external link icon -->
              </a>
            </div>
          </div>
          <div v-else-if="lab.remote_url">
            <a :href="lab.remote_url" target="_blank" rel="noopener" class="flex items-center gap-2 text-blue-600 hover:text-blue-800 underline">
              Launch {{ lab.title }}
              <font-awesome-icon icon="external-link-alt" /> <!-- Font Awesome external link icon -->
            </a>
          </div>
          <div v-if="lab.source_url" class="mt-2">
            <a :href="lab.source_url" target="_blank" rel="noopener"
              class="flex items-center gap-2 text-blue-600 hover:text-blue-800 underline">
              View the source on GitHub
              <font-awesome-icon icon="external-link-alt" />
            </a>
          </div>
        </div>
      </section>

      <section v-if="lab.seeking_investment" class="my-12 rounded-lg border-l-4 border-amber-500 bg-amber-50 p-6">
        <h2 class="text-2xl font-orbitron font-semibold">We are raising for {{ lab.title }}</h2>
        <p class="mt-3 text-lg font-roboto text-gray-800">
          We are looking for investors to take {{ lab.title }} from working system to product. Get in touch and we
          will send you the detail.
        </p>
        <router-link :to="{ path: '/contact', query: { service: `Investment — ${lab.title}` } }"
          class="btn-primary mt-6">
          Talk to us about investing
        </router-link>
      </section>

      <section class="my-12 border-t border-gray-200 pt-8">
        <p class="text-lg font-roboto text-gray-700">Want something like this built for your own problem?</p>
        <router-link to="/contact" class="btn-primary mt-6">Start a project</router-link>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { marked } from 'marked';
import { applyMeta } from '@/seo';

export default {
  data() {
    return {
      lab: {},
      loading: false,
      error: null,
    };
  },
  created() {
    this.fetchLabData();
  },
  methods: {
    convertMarkdownToHtml(markdown) {
      return marked.parse(markdown || '');
    },
    fetchLabData() {
      this.loading = true;
      this.error = null;

      axios.get(`/api/labs/${this.$route.params.permalink}`)
        .then(response => {
          this.lab = response.data;
          applyMeta({
            path: this.$route.path,
            title: `${this.lab.title} — A.I. Robotika Labs`,
            description: this.lab.short_summary,
            image: this.lab.image,
          });
        })
        .catch(() => {
          this.error = "We could not load this project.";
          applyMeta({ path: this.$route.path, title: 'Project not found — A.I. Robotika' });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style scoped>
.lab-content-text ol {
  padding: 1rem 2rem;
}

.font-roboto {
  font-family: 'Roboto', sans-serif;
}

.font-orbitron {
  font-family: 'Orbitron', sans-serif;
}

.lab-loading {
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 18px;
}

.lab-error {
  padding: 20px;
  text-align: center;
  color: #b00;
  font-size: 18px;
  background-color: #fee;
  border: 1px solid #fbb;
  border-radius: 8px;
}
</style>
